import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from './components/ui/toaster';
import { AnimatePresence } from 'framer-motion';
import GTMLoader from './components/GTMLoader';
import TimezoneSelectionModal from './components/TimezoneSelectionModal';

// Route groups
import publicRoutes from './routes/publicRoutes';
import { userRoutes, trainerRoutes, adminRoutes } from './routes/protectedRoutes';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [pathname]);

  return null;
};

function AppRoutes() {
  const location = useLocation();
  const { user, needsTimezoneSetup, updateTimezone } = useAuth();

  const handleTimezoneUpdate = async (timezoneData) => {
    const result = await updateTimezone(timezoneData);
    if (!result.success) {
      console.error('Failed to update timezone:', result.message);
    }
  };

  return (
    <>
      {/* Timezone Selection Modal - shows when user needs to set timezone */}
      <TimezoneSelectionModal
        isOpen={needsTimezoneSetup}
        onSave={handleTimezoneUpdate}
        userName={user?.name}
      />

      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {publicRoutes}
          {userRoutes}
          {trainerRoutes}
          {adminRoutes}

          {/* Fallback - MUST BE LAST */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <ScrollToTop />
            <GTMLoader />
            <AppRoutes />
            <Toaster />
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
